import Vue from "vue";

import Checkpoint, { ORDER_EXCLUDED } from "./checkpoint";
import {filterExclusionCheckpoint} from "./index";

export default class FilterExclusionCheckpoint extends Checkpoint {
    constructor() {
        super('filterExclusionCheckpoint', 'JourneyBuilder_Checkpoint_FilterExclusion', 'JourneyBuilder_Checkpoint_FilterExclusion_Description', { iconClass: 'far fa-list-alt' })
    }

    get defaultOrder(){
        return ORDER_EXCLUDED;
    }

    isConfiguredForConnection(connection){
        return true; //Does not have an actual configuration
    }

    activateForConnection(journey, connection) {
        const retVal = super.activateForConnection(journey, connection);

        //We may be explicitly disabled for the given connection
        if(!this.isActiveForConnection(connection)) {
            return;
        }

        //All filters are 'activated' by default for exclusion checkpoints
        const exclusionConfig = filterExclusionCheckpoint.readForConnection(connection);
        const journeyFilters = (journey.config && journey.config.filters) || [];

        journeyFilters
            .forEach(filterGroup => this.toggleFilterExclusion(exclusionConfig, filterGroup.id, true));

        Checkpoint.updateOrderForConnection(journey, connection);

        return retVal;
    }

    buildTooltip(connection) {
        return {
            title: 'Filter exclusion checkpoint',
        };
    }

    /**
     * Toggle the given filter for exclusion in the given connection configuration
     * @param {Object} config connection configuration
     * @param {String} filterId
     * @param {boolean} isExcluded
     */
    toggleFilterExclusion(config, filterId, isExcluded) {
        if(!config.excludedFilters){
            Vue.set(config, 'excludedFilters', []);
        }

        if(isExcluded){
            config.excludedFilters.push(filterId);
        } else {
            const filterIndex = config.excludedFilters.indexOf(filterId);

            if(filterIndex !== -1) {
                config.excludedFilters.splice(filterIndex, 1);
            }
        }
    }
}